import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV_LINKS } from "../config/site";
import { SERVICES } from "../data/content";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            {SITE.tagline}. Mobile and on-site testing across Eastern Iowa — we come to you.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-teal-400">Explore</h4>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-sm text-slate-300 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-teal-400">Services</h4>
          <ul className="mt-4 space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}>
                <Link
                  to={`/services#${s.id}`}
                  className="text-sm text-slate-300 transition-colors hover:text-white"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-teal-400">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a
                data-testid="footer-phone-link"
                href={`tel:${SITE.phoneTel}`}
                className="flex items-center gap-2.5 transition-colors hover:text-white"
              >
                <Phone className="h-4 w-4 text-teal-400" /> {SITE.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email-link"
                href={`mailto:${SITE.email}`}
                className="flex items-center gap-2.5 transition-colors hover:text-white"
              >
                <Mail className="h-4 w-4 text-teal-400" /> {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5 text-slate-400">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-teal-400" />
              <span>Mobile &amp; on-site service only — we travel to you across Eastern Iowa.</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-slate-500 sm:flex-row sm:px-8">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </span>
          <span>Confidential, certified, and chain-of-custody documented.</span>
        </div>
      </div>
    </footer>
  );
}
